const skSystemActivityEvents = {
  tableColumns: {
    createdDateTime: 'Čas udalosti',
    code: 'Kód',
    logLevel: 'Log level',
    event: 'Udalosť',
    tags: 'Tagy',
    creator: 'Vytvoril',
    emsPartyId: 'Identifikátor vlastníka',
    emsPartyName: 'Vlastník',
    balancingGroupId: 'Identifikátor bilančnej skupiny',
    balancingGroupName: 'Bilančná skupina',
    deviceId: 'Identifikátor zariadenia',
    deviceName: 'Zariadenie'
  },
  filter: {
    dateTimeFilterValue: 'Hodnota',
    beforeFilterLabel: 'je pred',
    onOrAfterFilterLabel: 'je po'
  },
  dateFrom: 'Dátum od',
  dateTo: 'Dátum do',
  dateRangeError: 'Zadajte dátumový rozsah maximálne týždeň'
};

export default skSystemActivityEvents;
